import { dictionary } from "@/schemas/dictionary";
import { z } from "@/zod";

const shiftListItem = dictionary.extend({
  description: z.string().max(250).optional(),
});

const shift = shiftListItem.extend({
  shift_begin: z.string().min(1),
  shift_end: z.string().min(1),
  mandatory: z.boolean(),
});

export const readShiftListItem = shiftListItem.readonly();

export const readShift = shift.readonly();
export const writeShift = shift.omit({
  id: true,
});
